import { Controller } from 'react-hook-form';
import { Flex, Text, TextArea, ScreenReaderContent, Alert } from '@smarterservices/smarter-ui';

const CommentInput = ({ name, control, question, required, error }) => {
    
    const commentFieldName = `${name}_comment`;
    return (
    <Controller
      name={commentFieldName}
      control={control}
      rules={{
        required: required ? 'This field is required' : false,
        validate: value => !required || value?.trim() !== '' || 'This field is required'
      }}
      render={({ field, fieldState: { error: fieldError } }) => {
        const errorMessage = fieldError?.message || error?.message;
        return (
          <Flex direction="column" gap="x-small">
            {errorMessage && (
              <Alert variant="error" title="Error">
                {errorMessage}
              </Alert>
            )}
            <Text as="div" size="large">
              {question.question?.en_US || 'Additional comments'}
              {required && <Text color="danger" size="x-large">*</Text>}
            </Text>
            <TextArea
              label={<ScreenReaderContent>{question.question?.en_US || 'Additional comments'}</ScreenReaderContent>}
              placeholder="Please share your additional comments..."
              maxHeight="10rem"
              margin="small 0 0 0"
              validationState={errorMessage ? 'error' : 'default'}
              messages={errorMessage ? [{ text: null, type: 'error' }] : []}
              {...field}
            />
          </Flex>
        );
      }}
    />
  )
};

export default CommentInput;